import { render, staticRenderFns } from "./asignar-numeros-manual.vue?vue&type=template&id=94489614&"
import script from "./asignar-numeros-manual.vue?vue&type=script&lang=js&"
export * from "./asignar-numeros-manual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports